import { ChannelState } from './types';

export const initialState: ChannelState = {
  registrationQuestions: [],
  loadingRegistrationQuestions: false,
};
